<template>
  <SelectMultipleInput
    v-model="model"
    :items="items"
    item-text="text"
    item-value="inspCat"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
    @change="onChange"
  />
</template>

<script>
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'InspCat2MultipleInput',

  mixins: [APIUtils, Message],

  components: { SelectMultipleInput },

  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0117')
      },
    },
  },

  methods: {
    onChange(value) {
      let itemDetail = this.items.find((item) => item.inspCat == value)
      this.$emit('change', itemDetail)
    },
  },

  async mounted() {
    this.loading = true
    try {
      let params = {
        validOnly: this.validOnly,
      }
      const elements = await API.get('/master/inspCats/cat2', params)
      elements.forEach((element) => {
        element['text'] = element['inspCat'] + ' : ' + element['inspCatName']
        this.items.push(element)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0117') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
